export const adminMenu = [
  'General',
  [
    {
      href: '/',
      icon: 'dashboard',
      label: 'Dashboard'
    }
  ],
  'Management',
  [
    {
      href: '/sector-targets',
      label: 'Sector Targets',
      icon: 'bullseye',
    },
    {
      href: '/verticals',
      label: 'Verticals',
      icon: 'building',
    },
    {
      href: '/markets',
      label: 'Markets',
      icon: 'people',
    },
    {
      href: '/leads',
      label: 'Leads',
      icon: 'address-card',
    },
  ],
  //   {
  //     to: '/forms',
  //     label: 'Forms',
  //     icon: 'square-edit-outline'
  //   },
  //   {
  //     to: '/profile',
  //     label: 'Profile',
  //     icon: 'account-circle'
  //   },
  //   {
  //     label: 'Dropdown',
  //     icon: 'arrow-down-bold-circle',
  //     menu: [
  //       {
  //         href: '#void',
  //         label: 'Sub-item One'
  //       },
  //       {
  //         href: '#void',
  //         label: 'Sub-item Two'
  //       }
  //     ]
  //   },
  //   {
  //     label: 'Submenus',
  //     icon: 'view-list',
  //     menuSecondaryKey: 'submenu-1',
  //     menuSecondaryIcon: 'view-list',
  //     menuSecondaryLabel: 'Example',
  //     menuSecondary: [
  //       'Something',
  //       [
  //         {
  //           icon: 'view-list',
  //           href: '#void',
  //           label: 'Sub-item One'
  //         },
  //         {
  //           icon: 'view-list',
  //           href: '#void',
  //           label: 'Sub-item Two'
  //         }
  //       ],
  //       'Dropdown',
  //       [
  //         {
  //           label: 'Submenus',
  //           icon: 'view-list',
  //           menu: [
  //             {
  //               href: '#void',
  //               label: 'Sub-item One'
  //             },
  //             {
  //               href: '#void',
  //               label: 'Sub-item Two'
  //             }
  //           ]
  //         }
  //       ]
  //     ]
  //   }
  // ],
  // 'Other',
  // [
  //   {
  //     to: '/login',
  //     label: 'Login',
  //     icon: 'lock'
  //   },
  //   {
  //     to: '/error-in-card',
  //     label: 'Error v.1',
  //     icon: 'power-plug'
  //   },
  //   {
  //     to: '/error-simple',
  //     label: 'Error v.2',
  //     icon: 'alert-decagram'
  //   },
  //   {
  //     to: '/lock-screen',
  //     label: 'Lock Screen',
  //     icon: 'lock-reset'
  //   }
  // ],
  // 'About',
  // [
  //   {
  //     href: 'https://justboil.me/bulma-admin-template/one',
  //     label: 'About',
  //     icon: 'help-circle'
  //   }
  // ]
]
export const customerMenu = [
  'General',
  [
    {
      href: '/customer/dashboard',
      icon: 'dashboard',
      label: 'Dashboard'
    }
  ],
  'Management',
  [
    // {
    //   href: '/customer/businesses',
    //   label: 'Businesses',
    //   icon: 'building',
    // },
    {
      href: '/customer/leads',
      label: 'Leads',
      icon: 'address-card',
    },
  ],
]
export const menuBottom = [
  {
    action: 'logout',
    icon: 'logout',
    label: 'Log out',
    state: 'info'
  }
]
